import Box from '@mui/material/Box';
import { useNavigate } from 'react-router';

import NoContent from '@/assets/icons/Statistics/NoContent';
import Button from '@/components/Button';

const NoShipmentsYet = () => {
  const navigate = useNavigate();

  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <NoContent sx={{ fontSize: 100 }} />
      <h4>Parece que no tienes ningún pedido</h4>
      <Button sx={{ mt: '0.5rem' }} onClick={() => navigate('/')}>
        Crear pedido
      </Button>
    </Box>
  );
};

export default NoShipmentsYet;
